import { BrickGridSettingsRealTimeData } from '../../../../../../generated/signalR/brick-grid-settings-real-time-data';
import { IBrickInstanceTargetingAction } from '../../../../utility/IBrickInstanceTargetingAction';
import { LongRunningAction } from '../../../../server-communication/running-actions/types/longRunningAction.decorator';
import { LongRunningContextCategoryTyp } from '../../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { ColumnSetting } from '../../../../../samwebDescription/samweb/dashboard/grid-column-settings';

export class BrickGridColumnChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[BrickGridsState] brick grid columns changed';

   constructor(public brickInstanceId: string, public gridId: string, public columnSettings: ColumnSetting[]) {}
}

export class BrickGridColumnOrderChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[BrickGridsState] brick grid column order changed';

   constructor(
      public brickInstanceId: string,
      public gridId: string,
      public targetColumnSetting: ColumnSetting,
      public newOrderIndex: number,
      public oldOrderIndex: number
   ) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class PersistGridColumnSettings implements IBrickInstanceTargetingAction {
   public static readonly type = '[BrickGridsState] persist unsaved grid column settings';

   constructor(public brickInstanceId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class BrickGridSettingsUpdatedByServer {
   public static readonly type = '[BrickGridsState] brick grid settings updated by server';

   constructor(public data: BrickGridSettingsRealTimeData) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.BRICK_WALL)
export class PersistAllGridColumnSettings {
   public static readonly type = '[BrickGridsState] persist all unsaved grid column settings';

   constructor(public brickIds: string[]) {}
}
